<template>
  <BaseView>
    <Media />
  </BaseView>
</template>

<script lang="ts" setup>
import BaseView from '@/views/BaseView.vue'
import Media from '@/app/views/About/Media.vue'
</script>
